import SettingsAPI from '@/services/api/api-settings';
import {SETTINGS_ENUM} from "@/const/settings.enum";

export default {
  namespaced: true,

  state: () => ({
    [SETTINGS_ENUM.ALLOW_APPLICATION_IDS]: null,
    [SETTINGS_ENUM.CBR_ENABLED]: null,
    [SETTINGS_ENUM.PRACTICE_ENABLED]: null,
    [SETTINGS_ENUM.READING_ENABLED]: null,
    [SETTINGS_ENUM.REGISTRATION_ENABLED]: null,
    [SETTINGS_ENUM.VIDEO_ENCODING_ENABLED]: null,
  }),

  mutations: {
    set(state, settings) {
      Object.keys(settings).forEach(key => state[key] = settings[key]);
    }
  },

  actions: {
    async fetch({ commit }) {
      try {
        let res = await SettingsAPI.fetch();
        commit('set', res);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }
};
